import React from 'react'
import { Field } from 'formik'
import { Form } from '_zari/core'

const FlagBolsaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagBolsa'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagBolsa'
          label='ICBPER'
        />
      )}
    </Field>
  )
}

export default FlagBolsaFormGroup
